export default __webpack_public_path__ + "static/media/search-20.ebdfe749.svg";